import { useContext, useEffect, useState } from "react";
import css3 from "../Approvals/css/approval-table.module.css";
import { FiMoreHorizontal as MoreIcon } from "react-icons/fi";
import {
  MdOutlineArrowBackIosNew as LBtn,
  MdOutlineArrowForwardIos as RBtn,
} from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { useSettingModal } from "../../../hooks/Context";
import ViewDetails from "./Modal/ViewDetails";

const DATA_PER_PAGE = 10;

const InductionInvitesTable = (props: any) => {
  const [activeData, setActiveData] = useState<any>([]);
  const [pageData, setPageData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [pageArr, setPageArr] = useState<any>([]);
  const [showMore, setShowMore] = useState<boolean>(false);
  const [showIndex, setShowIndex] = useState<any>(null);
  const [showSpan, setShowSpan] = useState<boolean>(false);
  const [spanIndex, setSpanIndex] = useState<null | number>(null);
  const { setShowModal, setModalContent } = useSettingModal();
  const data: any = props.data;
  // const data = [
  //   {
  //       applicantId: 'applicant Id',
  //       firstName: 'first Name',
  //       lastName: 'Last Name',
  //       certificateScore: 'Certificate Score',
  //       InductionScore: 'Induction Score',
  //       route: 'Route'
  //   }
  // ]

  const handleMore = (index: number) => {
    if (index == showIndex) {
      setShowIndex(null);
      setShowMore(false);
      return;
    }
    setShowIndex(index);
    setShowMore(true);
  };
  const handleSpan = (index: number) => {
    if (index == spanIndex) {
      setSpanIndex(null);
      setShowSpan(false);
      return;
    }
    setSpanIndex(index);
    setShowSpan(true);
  };

  const handleViewDetails = (data: any) => {
    setModalContent(<ViewDetails data={data} />);
    setShowModal(true);
  };

  useEffect(() => {
    if (data && data.length > 0) {
      setActiveData(data);
      let lastPage = Math.ceil(data.length / 10);
      let i = 0;
      let arr = [];
      for (i = 0; i < lastPage; i++) {
        arr.push(i);
      }
      setPageArr(arr);
      setPageData(data.slice(0, DATA_PER_PAGE));
    }
  }, [data]);

  useEffect(() => {
    if (activeData && activeData.length > 0) {
      let start = currentPage * DATA_PER_PAGE;
      let stop = start + DATA_PER_PAGE;
      setPageData(data.slice(start, stop));
    }
  }, [currentPage]);

  return (
    <div className={css3.container}>
      <>
        <div style={{ gridTemplateColumns: `0.8fr 1.2fr 1.2fr 1.1fr` }}>
          <div>Applicant ID</div>

          <div>Applicant Name</div>
          <div>Applicant Email</div>
          <div>Applicant PhoneNumber</div>
        </div>
        <div>
          {pageData &&
            pageData.length > 0 &&
            pageData.map((eData: any, index: number): any => (
              <div
                key={index}
                style={{ gridTemplateColumns: `0.8fr 1.2fr 1.2fr 1.1fr ` }}
              >
                <div onClick={() => handleSpan(index)}>
                  {eData.ApplicantId.slice(0, 12)}...
                </div>
                <div onClick={() => handleSpan(index)}>
                  {eData.ApplicantName}
                </div>

                <div onClick={() => handleSpan(index)}>
                  {eData.ApplicantEmail}
                </div>

                <div>
                  <div onClick={() => handleSpan(index)}>
                    {eData.ApplicantPhone}
                  </div>

                  <span
                    className={`${css3.moreSpan} ${
                      index == showIndex ? `${css3.activeMore}` : ""
                    } `}
                    onClick={() => handleMore(index)}
                  >
                    <MoreIcon />
                    {index == showIndex && showMore ? (
                      <div>
                        <div onClick={() => handleViewDetails(eData)}>
                          View Details
                        </div>
                        {/* <div onClick={() => handleApproveOrDecline(eData)}>Decline | Approve</div> */}
                      </div>
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </div>
            ))}
        </div>
        
        <div className={css3.pagination}>
          <div>
            <button className={`${css3.lBtn} ${css3.btn}`}>
              <LBtn />
            </button>
            {pageArr &&
              pageArr.length > 0 &&
              pageArr.map((ePage: number) => (
                <span
                  style={
                    ePage == currentPage
                      ? {
                          backgroundColor: "var(--activeP-back)",
                          color: "var(--white-color)",
                        }
                      : {}
                  }
                  key={ePage}
                  onClick={() => setCurrentPage(ePage)}
                >
                  {ePage + 1}
                </span>
              ))}
            <button className={`${css3.rBtn} ${css3.btn}`}>
              <RBtn />
            </button>
          </div>
        </div>
      </>
    </div>
  );
};

export default InductionInvitesTable;
